export const DASHBOARD_MESSAGE_NOTIFICATION_TAGS = ['Stocks', 'Updates', 'Training', 'Events'] as const;

export type DashboardMessageNotificationTag = (typeof DASHBOARD_MESSAGE_NOTIFICATION_TAGS)[number];

const dashboardMessagesMap = new Map<DashboardMessageNotificationTag, string>([
    ['Stocks', 'Акции'],
    ['Updates', 'Обновления'],
    ['Training', 'Обучение'],
    ['Events', 'События'],
]);

export const formatDashboardMessageTagLabel = (tag: DashboardMessageNotificationTag): string =>
    `# ${dashboardMessagesMap.get(tag)}`;
